export function stateOptions(t) {
    return [
        t('balance.filter.state.canceled'),
        t('balance.filter.state.processing'),
        t('balance.filter.state.requires_action'),
        t('balance.filter.state.requires_capture'),
        t('balance.filter.state.requires_confirmation'),
        t('balance.filter.state.requires_payment_method'),
        t('balance.filter.state.succeeded'),
    ];
}

export const stateStripeOpt = [
    'canceled',
    'processing',
    'requires_action',
    'requires_capture',
    'requires_confirmation',
    'requires_payment_method',
    'succeeded',
];

export function getStateColor(state) {
    switch (state) {
        case 'canceled':
            return 'red-mark';
        case 'processing':
            return 'yellow-mark';
        case 'requires_action':
            return 'yellow-mark';
        case 'requires_capture':
            return 'yellow-mark';
        case 'requires_confirmation':
            return 'yellow-mark';
        case 'requires_payment_method':
            return 'yellow-mark';
        case 'succeeded':
            return 'green-mark';
        default:
            return '';
    }
}